'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Copy, Check } from 'lucide-react'
import { useToast } from './hooks/use-toast'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'


interface CopyButtonProps {
  text: string
}

export function CopyButton({ text }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)
  const { toast } = useToast()

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      toast({
        description: "Prompt copied!",
        duration: 1200,
      })
      const timer = setTimeout(() => {
        setCopied(false)
      }, 2000) // 2 seconds
      return () => clearTimeout(timer)
    })
    .catch(() => {
      toast({
        description: "Failed. Try again :(",
        duration: 1200,
      })
    })
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger className="absolute right-4 top-4">
          <Button
            aria-label='copy prompt'
            size="icon"
            variant="default"
            onClick={handleCopy}
          >
            {copied ? (
              <Check className="h-4 w-4 text-slate-50" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
            <span className="sr-only">{copied ? 'Copied!' : 'Copy prompt'}</span>
          </Button>
          <TooltipContent className='bg-slate-900 text-slate-100'>
          <p>{copied ? 'Copied!' : 'Copy prompt'}</p>
          </TooltipContent>
        </TooltipTrigger>
      </Tooltip>
    </TooltipProvider>
  )
}
